import generateNumberArray from '../utils/generateNumberArray';

const useTargetNumberOptions = () => {
  const targetNumbers = generateNumberArray(10, 100, 10);
  const formattedTargetNumbers = targetNumbers.map((age) => ({ label: String(age), value: age }));

  return formattedTargetNumbers;
};

export default useTargetNumberOptions;
